import { apiBaseURL } from '../ProjectConstants';


async function handlePostAddMiscCosts(fileData, fetch) {
	console.log('handlePostAddMiscCosts', fileData)
	const body = fileData;

	//const response = null;
	const response = await fetch.postFile(`${apiBaseURL}/api/projects/misccost`, fileData);
	const isDataGood = response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';
	
	console.log('handlePostAddMiscCosts body', body);
	console.log('handlePostAddMiscCosts response', response);

	return {
		response,
		isDataGood
	};
}
export default handlePostAddMiscCosts;